import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_3 = { class: "d-flex flex-stack mb-2" }
const _hoisted_4 = { class: "text-muted me-2 fs-8 fw-bold text-nowrap ms-auto" }
const _hoisted_5 = { class: "progress h-8px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    class: "box-item",
    effect: "light",
    placement: "left"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isPast)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", null, "Booked: " + _toDisplayString(_ctx.crew.booked), 1),
              _createElementVNode("span", null, "Applied positions: " + _toDisplayString(_ctx.crew.applied), 1),
              _createElementVNode("span", null, "Empty positions: " + _toDisplayString(_ctx.crew.free), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", null, "Filled positions: " + _toDisplayString(_ctx.crew.booked), 1),
              _createElementVNode("span", null, "Empty positions: " + _toDisplayString(_ctx.crew.free), 1)
            ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.crewSummary), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "progress-bar bg-success",
            style: _normalizeStyle(_ctx.progressStyle('booked'))
          }, null, 4),
          (!_ctx.isPast)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "progress-bar bg-warning",
                style: _normalizeStyle(_ctx.progressStyle('applied'))
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "progress-bar bg-danger",
            style: _normalizeStyle(_ctx.progressStyle('free'))
          }, null, 4)
        ])
      ])
    ]),
    _: 1
  }))
}